import api from '../api';
import querystring from 'querystring';


class GamificationData {

  getUserById(idUser) {
    api.post('/user-data/', idUser);
  }

  createTransaction(data) {
    if (data.amount && typeof data.amount === 'string') {
      data.amount = parseInt(data.amount, 10); 
    }
    return api.post('/gamification-transactions', data);
  }

  getTotalCoinsByUserId(userId) {
    return api.post('/user-coins', userId);
  }

  getAllUserCoins(params) {
    const url = 'user-coins?' + querystring.stringify(params);
    return api.get(url); 
  } 
  
  getRankingUserCoins() {
    return api.get('/user-coins-ranking');
  }

  getAllTransactions(userId) {
    return api.post('/transactions', userId);
  }

  getAllRewards(params) {
    const url = 'all-rewards?' + querystring.stringify(params);
    return api.get(url);
  }

  getRewardById(idReward) {
    const { id } = idReward;
    return api.post(`/get-reward/${id}`);
  }

  createReward(data) {
    return api.post('/rewards', data);
  }

  updateReward(data) {
    return api.put('/rewards', data);
  }

  deleteReward(data) {
    const { id } = data;
    return api.delete(`/rewards/${id}`);
  }

  createRescue(reward) {
    return api.post('/user-rewards', reward);
  }

  getGamificationByIdCompany(idCompany) {
    return api.post('/gamification-by-company', idCompany);
  }

  updateGamification({coin_name, score, id_company}) {
    return api.put('/gamification', {
      coin_name, score, id_company
    });
  }

  getUserRewards(params) {
    return api.get('/user-rewards?' + querystring.stringify(params));
  }

  getIdAdminUserByCompanyId(id_company) {
    return api.post('/transaction-admin', id_company);
  }

  updateStatusGamification(id, status_rescue, item, id_admin) {
    return api.put(`/transaction-admin-status/${id}`, {id, status_rescue, item, id_admin});
  }

}

export default new GamificationData();
